export const dictionary = {
  en: { login: 'Login', register: 'Register', no_data_found: "No data found" },
  nl: { login: 'Inloggen', register: 'Registreren' },
  fr: { login: 'Se connecter', register: 'Enregistrer', no_data_found: "Aucune donnée trouvée" }
};